import { createContext } from 'react';
import type { TreeInteractor, TreeState } from './TreeInteractor';

export interface TreeInteractorContextValue {
	interactor: TreeInteractor;
	treeState: TreeState;
}

/** Shared context object used by TreeInteractorProvider and test harnesses. */
export const TreeInteractorContext = createContext<TreeInteractorContextValue | null>(null);
